import classnames from 'classnames';
import { forEach, isEmpty, isObject } from 'lodash';
import React, { useCallback } from 'react';
import useEntityFormContext from '../containers/EntityForm/internal/useEntityFormContext';
import useLayoutDirection from '../utils/Translations/useLayoutDirection';
import Ripple from '../utils/Ripple';
function ButtonDropdown({ disabled = false, actions = [], additionClasses, additionClassesBtn, clickableBtn, children, isSubmitTogglesDropdown = false, dataCy, }) {
    const { values, setSubmitting, validateForm, setErrors, setTouched, } = useEntityFormContext();
    const { isLayoutRTL } = useLayoutDirection();
    const handleClick = useCallback((onClick, validate = false) => async () => {
        if (validate) {
            const errors = await validateForm(values);
            //TODO: workaround for formik bug https://github.com/formik/formik/issues/1580
            if (!isEmpty(errors)) {
                //TODO: fix for bug EFS-2723
                setTouched(walkOfTrue(errors));
                return setErrors(errors);
            }
        }
        try {
            setSubmitting(true);
            await onClick(values);
        }
        finally {
            setSubmitting(false);
        }
    }, [setTouched, validateForm, setSubmitting, values, setErrors]);
    return actions.length ? (<>
      <Ripple key="button">
        <>
          {isLayoutRTL ? (<>
              <button className={classnames(additionClasses, 'btn btn-primary dropdown-toggle')} data-cy={dataCy ? `${dataCy}-toggle` : undefined} data-toggle="dropdown" disabled={disabled} type="button">
                <span className="caret"/>
              </button>
              {isSubmitTogglesDropdown ? (<button className={classnames(additionClassesBtn, 'btn btn-primary btn-rounded')} data-cy={dataCy ? `${dataCy}-button` : undefined} data-toggle={!clickableBtn ? 'dropdown' : ''} disabled={disabled} type="button" 
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    onClick={clickableBtn &&
        handleClick(actions[0].onClick, actions[0].validate)}>
                  {children}
                </button>) : null}
            </>) : (<>
              {isSubmitTogglesDropdown ? (<button className={classnames(additionClassesBtn, 'btn btn-primary btn-rounded')} data-cy={dataCy ? `${dataCy}-button` : undefined} data-toggle={!clickableBtn ? 'dropdown' : ''} disabled={disabled} type="button" 
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    onClick={clickableBtn &&
        handleClick(actions[0].onClick, actions[0].validate)}>
                  {children}
                </button>) : null}
              <button className={classnames(additionClasses, 'btn btn-primary dropdown-toggle')} data-cy={dataCy ? `${dataCy}-toggle` : undefined} data-toggle="dropdown" disabled={disabled} type="button">
                <span className="caret"/>
              </button>
            </>)}
        </>
      </Ripple>
      <ul key="dropdown" className={classnames('dropdown-menu', {
        'dropdown-menu-right': !isLayoutRTL,
    })}>
        {actions.map(({ text, onClick, validate }) => (<li key={text}>
            <a data-cy={dataCy ? `${dataCy}-item` : undefined} onClick={handleClick(onClick, validate)} className={classnames({
        'text-right': isLayoutRTL,
    })}>
              {text}
            </a>
          </li>))}
      </ul>
    </>) : null;
}
export default ButtonDropdown;
const walkOfTrue = values => {
    const touched = {};
    forEach(values, (v, k) => isObject(v) ? (touched[k] = walkOfTrue(v)) : (touched[k] = true));
    return touched;
};
